import { E_ROUTE_PATSNAPLAB } from './route.types';
export const functionalAudit = [
    {
        name: 'patsnap-lab',
        path: '/patsnap-lab',
        component: () => import(/* webpackChunkName: "functional" */ '../../views/functional-audit/FunctionalAudit/FunctionalAudit.vue'),
        redirect: '/',
        children: [{
                name: E_ROUTE_PATSNAPLAB.PATSNAP_LAB,
                path: '/',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/functional-audit/PatsnapLab/PatsnapLab.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'Patsnap Lab',
                        },
                        {
                            text: 'backoffice.nav.patsnap_lab',
                            active: true,
                        }
                    ],
                    permission: 'AppManagement',
                },
            }, {
                name: E_ROUTE_PATSNAPLAB.PATSNAP_LAB_ANALYSIS,
                path: 'patsnap-lab-analysis',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/functional-audit/PatsnapLabAnalysis/PatsnapLabAnalysis.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'Patsnap Lab',
                        },
                        {
                            text: 'backoffice.nav.patsnap_lab_analysis',
                            active: true,
                        }
                    ],
                    permission: 'AppAnalysis',
                },
            }, {
                name: E_ROUTE_PATSNAPLAB.PATSNAP_LAB_FEEDBACK,
                path: 'patsnap-lab-feedback',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/functional-audit/Feedback/Feedback.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'Patsnap Lab',
                        },
                        {
                            text: 'backoffice.nav.patsnap_lab_feedback',
                            active: true,
                        }
                    ],
                    permission: 'SuggestionFeedback',
                },
            }],
    },
    {
        name: 'navigation-library',
        path: '/navigation-library',
        redirect: { name: 'navigation-library-audit' },
        component: () => import(/* webpackChunkName: "functional" */ '../../views/navigationLibrary/NavigationLibrary.vue'),
        props: true,
        meta: {
            permission: 'NavigationLibrary',
        },
        children: [
            {
                name: 'navigation-library-audit',
                path: '/navigation-library/audit',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/navigationLibrary/audit/Audit.vue'),
                props: true,
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.navigation_library',
                        },
                        {
                            text: 'backoffice.nav.navigation_library_audit',
                            active: true,
                        }
                    ],
                    permission: 'NavigationLibraryAudit',
                },
            },
            {
                name: 'navigation-library-agency',
                path: '/navigation-library/agency',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/navigationLibrary/agency/Agency.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.navigation_library',
                        },
                        {
                            text: 'backoffice.nav.agency_list',
                            active: true,
                        }
                    ],
                    permission: 'AgencyList',
                },
            },
            {
                name: 'navigation-library-operation',
                path: '/navigation-library/operation',
                component: () => import(/* webpackChunkName: "navigationLibraryOperation" */ '../../views/navigationLibrary/Operation/Operation.vue'),
                meta: {
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.navigation_library',
                        },
                        {
                            text: 'backoffice.nav.navigation_operation',
                            active: true,
                        }
                    ],
                    permission: 'AgencyList',
                },
            }
        ],
    },
    {
        name: 'ReleasePlan',
        path: '/release-plan',
        component: () => import(/* webpackChunkName: "functional" */ '../../views/release-plan/ReleasePlan.vue'),
        meta: {
            permission: 'ReleasePlan',
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'backoffice.nav.release_plan',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/ab-test',
        component: () => import(/* webpackChunkName: "functional" */ '../../views/abtest/index.vue'),
        redirect: '/',
        children: [{
                name: 'AbTest',
                path: '/',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/abtest/ABTest.vue'),
                meta: {
                    permission: 'AbTestManagement',
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.abtest',
                            active: true,
                        }
                    ],
                },
            },
            {
                name: 'AbTestEdit',
                path: 'edit',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/abtest/ABTestEdit.vue'),
                meta: {
                    permission: 'AbTestManagement',
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.abtest',
                            to: { name: 'AbTest' },
                        },
                        {
                            text: 'backoffice.common.edit',
                            active: true,
                        }
                    ],
                },
            }
        ],
    },
    {
        path: '/email-template-management',
        component: () => import(/* webpackChunkName: "functional" */ '../../views/email-template-management/index.vue'),
        redirect: '/home',
        children: [{
                name: 'EmailTemplateManagementHome',
                path: 'home',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/email-template-management/Home/Home.vue'),
                meta: {
                    permission: 'EmailTemplateManagement',
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.emailTemplateManagement',
                            active: true,
                        }
                    ],
                },
            }, {
                name: 'EmailTemplateManagementDetail',
                path: 'detail/:id',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/email-template-management/Detail/Detail.vue'),
                meta: {
                    permission: 'EmailTemplateManagement',
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.emailTemplateManagement',
                            to: {
                                name: 'EmailTemplateManagementHome',
                            },
                        },
                        {
                            text: 'backoffice.nav.emailTemplateManagementDetail',
                            active: true,
                        }
                    ],
                },
            }],
    },
    {
        path: '/prompt-management',
        component: () => import(/* webpackChunkName: "functional" */ '../../views/prompt-management/index.vue'),
        redirect: '/',
        children: [{
                name: 'PromptManagementHome',
                path: '/',
                component: () => import(/* webpackChunkName: "functional" */ '../../views/prompt-management/PromptManagement.vue'),
                meta: {
                    permission: 'PromptManagement',
                    breadcrumb: [
                        {
                            text: 'backoffice.nav.operation_tool',
                        },
                        {
                            text: 'backoffice.nav.promptManagement',
                            active: true,
                        }
                    ],
                },
            }
        ],
    },
    {
        path: '/organization',
        name: 'OrganizationManagementHome',
        component: () => import(/* webpackChunkName: "admin" */ '../../views/Organization/Organization.vue'),
        meta: {
            permission: 'OrganizationManagement',
            breadcrumb: [
                {
                    text: 'backoffice.nav.operation_tool',
                },
                {
                    text: 'department.title',
                    active: true,
                }
            ],
        },
    }
];
/**
 * 搜索引擎页面级子菜单
 * */
export const patsnapLabRoutePermissionTable = [
    { name: `${E_ROUTE_PATSNAPLAB.PATSNAP_LAB}`, permission: 'AppManagement' },
    { name: `${E_ROUTE_PATSNAPLAB.PATSNAP_LAB_ANALYSIS}`, permission: 'AppAnalysis' },
    { name: `${E_ROUTE_PATSNAPLAB.PATSNAP_LAB_FEEDBACK}`, permission: 'SuggestionFeedback' }
];
